export default __webpack_public_path__ + "static/mtsm-879195e776981f2e3d2c1fae91033fea.webp";